<template>
  <layouts-guest>
    <base-back-icon />
    <h1 class="text-title px-2">{{ t('not_found.title') }}</h1>
  </layouts-guest>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

import LayoutsGuest from '@/layouts/Guest.vue'
import BaseBackIcon from '@/components/BaseBackIcon.vue'

export default defineComponent({
  components: { LayoutsGuest, BaseBackIcon },
  setup() {
    const { t } = useI18n()

    return {
      t,
    }
  },
})
</script>
